/* CNC JOURNEY — the storefront moments Shopify's standard events don't see (Tracy 2026-10-13: "what about
   stuff on non cart stuff — PDP, collection page"). Each is published as a Shopify custom event named cnc_<what>;
   the C&C First-Party Journey pixel (shopify/first-party-web-pixel.js) forwards cnc_ events to first_party_event
   with this data as properties.detail. Analytics consent is honoured there, not here.

   Product page
     cnc_size_selected     a size/colour picked: { option, value, product }
     cnc_add_blocked       Add to bag pressed while it can't add (no size yet, sold out): { label, product }
     cnc_size_guide        the size guide opened: { product }
     cnc_details_opened    a details/accordion row opened: { label, product }
     cnc_gallery_depth     how many photos they looked at, sent once when they leave: { seen, total, product }
     cnc_reviews_seen      the reviews block reached the screen: { product }
   Collection
     cnc_filter_applied    a filter changed: { filters }      cnc_sort_changed  sort changed: { sort }
   Product, collection and home
     cnc_scroll_depth      50% and 90% of the page reached (each once): { pct, page }
   Small by design: every moment fires at most once per page view. */
(function () {
  var A = window.Shopify && window.Shopify.analytics;
  if (!A || typeof A.publish !== 'function') return;
  var path = location.pathname.replace(/^\/[a-z]{2}-[a-z]{2}(?=\/)/, '');
  var page = /^\/products\//.test(path) ? 'product' : /^\/collections\//.test(path) ? 'collection' : (path === '/' || path === '') ? 'home' : 'other';
  var product = (path.match(/^\/products\/([^/?#]+)/) || [])[1] || null;
  var sent = {};
  function pub(name, data, onceKey) {
    if (onceKey) { if (sent[onceKey]) return; sent[onceKey] = 1; }
    try { A.publish(name, data || {}); } catch (e) { /* never break the page */ }
  }

  if (page === 'product') {
    /* size / colour picked */
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('variant-selects, variant-radios, .product-form__input')) return;
      var fs = t.closest('fieldset'), legend = fs && fs.querySelector('legend');
      var opt = legend ? legend.textContent.replace(/size (guide|chart)/ig, '').replace(/\s+/g, ' ').trim().slice(0, 40) : (t.name || null);
      pub('cnc_size_selected', { option: opt, value: String(t.value || '').slice(0, 60), product: product });
    }, true);
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      /* Add to bag that can't add */
      var add = t.closest('button[name="add"], [id^="ProductSubmitButton"]');
      if (add && (add.disabled || add.getAttribute('aria-disabled') === 'true' || /select|sold out|unavailable/i.test(add.textContent || ''))) {
        pub('cnc_add_blocked', { label: (add.textContent || '').trim().slice(0, 40), product: product });
      }
      /* size guide */
      var link = t.closest('a, button, summary');
      if (link && /size (guide|chart)|fit guide|sizing/i.test(link.textContent || '')) pub('cnc_size_guide', { product: product }, 'sg');
      /* details rows (accordions) */
      var sum = t.closest('details > summary');
      if (sum && !/size (guide|chart)|sizing/i.test(sum.textContent || '')) {
        var label = (sum.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 40);
        pub('cnc_details_opened', { label: label, product: product }, 'd:' + label);
      }
    }, true);
    /* photos looked at: the furthest gallery item that came into view, sent once on leaving */
    var media = [].slice.call(document.querySelectorAll('.product__media-list > li, .product__media-item'));
    var seen = 0;
    if (media.length > 1 && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (x) { if (x.isIntersecting) seen = Math.max(seen, media.indexOf(x.target) + 1); });
      }, { threshold: 0.6 });
      media.forEach(function (m) { io.observe(m); });
      var leave = function () { if (seen) pub('cnc_gallery_depth', { seen: seen, total: media.length, product: product }, 'gd'); };
      addEventListener('pagehide', leave);
      document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') leave(); });
    }
    /* reviews reached */
    var rv = document.querySelector('#looxReviews, .loox-reviews-default, [data-cnc-reviews], .cnc-reviews');
    if (rv && 'IntersectionObserver' in window) {
      var io2 = new IntersectionObserver(function (es) {
        if (es.some(function (x) { return x.isIntersecting; })) { pub('cnc_reviews_seen', { product: product }, 'rv'); io2.disconnect(); }
      }, { threshold: 0.25 });
      io2.observe(rv);
    }
  }

  if (page === 'collection') {
    document.addEventListener('change', function (e) {
      var t = e.target, form = t && t.closest && t.closest('form');
      if (!form || !/facet|filter/i.test(form.id + ' ' + form.className)) return;
      if (t.name === 'sort_by') { pub('cnc_sort_changed', { sort: String(t.value || '').slice(0, 40) }); return; }
      var names = [].slice.call(form.querySelectorAll('input:checked')).map(function (i) { return String(i.value || '').slice(0, 40); }).slice(0, 10);
      pub('cnc_filter_applied', { filters: names });
    }, true);
  }

  if (page !== 'other') {
    var marks = [50, 90];
    var onScroll = function () {
      var h = document.documentElement.scrollHeight - innerHeight;
      if (h <= 0) return;
      var pct = (scrollY / h) * 100;
      marks.forEach(function (m) { if (pct >= m) pub('cnc_scroll_depth', { pct: m, page: page }, 'sd' + m); });
      if (sent.sd90) removeEventListener('scroll', onScroll);
    };
    addEventListener('scroll', onScroll, { passive: true });
  }
})();
